const pad2 = (value) => String(value).padStart(2, '0');

export const normalizeTimeValue = (timeValue) => {
  if (typeof timeValue === 'string' && timeValue.includes('-')) {
    return Math.floor(new Date(timeValue).getTime() / 1000);
  }
  if (typeof timeValue === 'number') {
    return timeValue > 1000000000000 ? Math.floor(timeValue / 1000) : timeValue;
  }
  // lightweight-charts business day object: { year, month, day }
  if (timeValue && typeof timeValue === 'object' && timeValue.year) {
    return Math.floor(Date.UTC(timeValue.year, timeValue.month - 1, timeValue.day) / 1000);
  }
  return timeValue;
};

export const chartTimeDayKey = (timeValue) => {
  if (timeValue && typeof timeValue === 'object' && timeValue.year) {
    return `${timeValue.year}-${pad2(timeValue.month)}-${pad2(timeValue.day)}`;
  }
  if (typeof timeValue === 'string') {
    const match = timeValue.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
  }
  const normalized = normalizeTimeValue(timeValue);
  if (typeof normalized !== 'number' || Number.isNaN(normalized)) return null;
  const date = new Date(normalized * 1000);
  return `${date.getUTCFullYear()}-${pad2(date.getUTCMonth() + 1)}-${pad2(date.getUTCDate())}`;
};

export const transactionLocalDayKey = (timestamp) => {
  if (!timestamp) return null;
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return null;
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
};

export const findTransactionMarkerDataPoint = (chartData = [], transactionTimestamp) => {
  if (!chartData || chartData.length === 0 || !transactionTimestamp) return null;

  const txDayKey = transactionLocalDayKey(transactionTimestamp);
  const normalizedChartData = chartData
    .map((point, index) => ({
      point,
      index,
      dayKey: chartTimeDayKey(point.time),
      normalizedTime: normalizeTimeValue(point.time),
    }))
    .filter(item => item.dayKey && typeof item.normalizedTime === 'number' && !Number.isNaN(item.normalizedTime));

  if (txDayKey) {
    const sameDay = normalizedChartData.find(item => item.dayKey === txDayKey);
    if (sameDay) return sameDay.point;
  }

  const txTime = normalizeTimeValue(new Date(transactionTimestamp).getTime());
  if (!txTime) return null;

  // If the exact calendar day is missing from sparse chart data, never place
  // a transaction in the future. Use the latest chart point at/before the tx.
  let previous = null;
  for (const item of normalizedChartData) {
    if (item.normalizedTime <= txTime && (!previous || item.normalizedTime > previous.normalizedTime)) {
      previous = item;
    }
  }
  if (previous) return previous.point;

  // If the transaction is before all chart data, use the first available point.
  return normalizedChartData[0]?.point || null;
};
